<template>
    <div class="base-input">
        <div class="base-input--title">
            <slot></slot>
        </div>
        <input 
            :type="type"
            :placeholder="placeholder" 
            class="base-input--input" 
            :class="{'error-border': isError}"
            :value="modelValue"
            @input="updateValue($event.target.value)"
            :disabled="disabled"
        />
        <div v-show="isError" class="error--text">{{ errorText }}</div>
    </div>
</template>

<script>
export default {
    name: 'MainInput',
    emits: ['update:modelValue', 'updateValue'],
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        isError: {
            type: Boolean,
            default: false
        },
        errorText: {
            type: String,
            default: ''
        },
        modelValue: {
            type: String,
            default: ''
        },
        fieldName: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        type: { type: String, default: 'text'},
    },
    methods: {
        updateValue(value) {
            this.$emit('update:modelValue', value)
            let field = {
                field: this.fieldName,
                value: value
            }
            this.$emit('updateValue', field)
        }
    }
}
</script>

<style lang="scss" scoped>
    .base-input {
        display: flex;
        width: 100%;
        position: relative;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        &--title {
            display: flex;
            align-items: flex-start;
            align-self: stretch;
            color: var(--text-text-prim, #1F1F29);
            font-feature-settings: 'clig' off, 'liga' off;
            font-family: Roboto;
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            line-height: 100%; /* 15px */
        }
        &--input {
            display: flex;
            height: 38px;
            padding: 16px 16px 16px 20px;
            align-items: center;
            gap: 12px;
            align-self: stretch;
            box-sizing: border-box;
            border-radius: 8px;
            border: 1px solid var(--lines-lines-btn, #E1E1EF);          
            background: var(--backgrounds-bkg-white, #FFF);
            outline: none;
            box-sizing: border-box;
            font-size: 15px;
            &::placeholder {
                color: var(--text-text-second, #9D9DB5);
                font-feature-settings: 'clig' off, 'liga' off;
                font-family: Roboto;
                font-size: 15px;
                font-style: normal;
                font-weight: 400;
                line-height: 110%; /* 17.6px */
            }
        }
    }
    .error-border {
        border: 1px solid var(--lines-lines-btn, #EA8A84); 
    }
    .error--text {
        display: flex;
        color: var(--red-red-500, #EA8A84);
        font-feature-settings: 'clig' off, 'liga' off;
        font-family: Roboto;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 100%; /* 13px */
    }
</style>